import { render } from "./BioplasticsScreenIntro.vue?vue&type=template&id=0763f084&scoped=true&ts=true"
import script from "./BioplasticsScreenIntro.vue?vue&type=script&lang=ts"
export * from "./BioplasticsScreenIntro.vue?vue&type=script&lang=ts"

import "./BioplasticsScreenIntro.vue?vue&type=style&index=0&id=0763f084&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0763f084"]])

export default __exports__